require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-6-reasons-for-pair-programming.json") })
        }
      }, "path---blog-6-reasons-for-pair-programming");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-6-reasons-for-pair-programming!./.cache/json/blog-6-reasons-for-pair-programming.json
// module id = 571
// module chunks = 231608221292675